import axios from 'axios'

export default (() => ({
  opened: false,
  sent: false,
  data: {
    email: '',
    name: ''
  },
  
  close() {
    this.sent = false
    this.opened = false
    this.data.email = ''
    this.data.name = ''
  },
  submit(e) {
    axios.post('/wp-json/ark-forms/submit', this.data)
      .then(res => {
        this.sent = true
        console.log(res)
      })
      .catch(e => {
        console.log(e)
      })
  }
}))